module.exports = __webpack_public_path__ + "img/logo.583f6ab7.png";